<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ODagey/tc-custom/9781504074902.jpg?1701632881583" alt="This image is the cover for the book Millionaire Baby"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Millionaire Baby
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The search for a missing child uncovers a wealthy family’s darkest secrets in this 1905 mystery by the author of <i>The Circular Study</i>.</b></p><p>On the morning of August 18, six-year-old heiress Gwendolen Ocumpaugh went missing from her family’s Hudson Valley estate. Now her parents are offering a fortune to anyone who can locate her, dead or alive. The distressing announcement causes a stir across New York, but it is a welcome opportunity for struggling private detective Mr. Trevitt. He knows the family. He knows the girl. And he could certainly use the money.</p> When one of Gwendolen’s shoes is found in the bushes and the. Other in the river, it seems to confirm the worst. But Mr. Trevitt smells a plot. As he continues his investigation, the shocking truth of Gwendolen’s whereabouts reveals buried secrets and devious deceptions.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anna Katharine Green
      </h2>
      
      <p class="authorDescription body article">Anna Katharine Green (1846&ndash;1935) was an American writer and one of the first authors of detective fiction in the United States. Her book <I>The Leavenworth Case</I>, published in 1878, became a wildly successful bestseller. Green went on to write dozens of mysteries and detective novels. She died in Buffalo, New York.&#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ef56b208